/**
 * Released Media Key Status.
 *
 * @group DRM
 *
 * @beta
 */
export const RELEASED = 'released';
